import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMass = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2938_30189",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 100,
		height: 100,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 99,
			height: 99,
			fill: "#C4C4C4",
			stroke: "#9EA9B9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_2938_30189)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask1_2938_30189",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: -3,
			y: -3,
			width: 105,
			height: 105,
			children: /* @__PURE__ */ _jsx("rect", {
				x: -3,
				y: -3,
				width: 105,
				height: 105,
				fill: "#C4C4C4"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask1_2938_30189)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M56.7706 12.9226L59.5835 18.314C60.1304 17.1419 61.3181 14.4697 61.6931 13.157C62.1619 11.5161 64.2717 8 59.1147 8C54.9891 8 55.8329 11.2817 56.7706 12.9226Z",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M56.6846 39.9226L59.4975 45.314C60.0445 44.1419 61.2321 41.4697 61.6072 40.157C62.076 38.5161 64.1857 35 59.0287 35C54.9031 35 55.747 38.2817 56.6846 39.9226Z",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M34.584 57.4998C40.6786 55.2339 54.2274 49.6237 59.6657 45.3105V45.4999C65.1041 49.813 78.6528 55.4231 84.7474 57.689V84.4149L59.6657 75.273L34.584 84.415V57.4998Z",
					fill: "#FDF1E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M59.6657 45.3105H60.1657C60.1657 45.1187 60.056 44.9438 59.8833 44.8604C59.7106 44.7769 59.5053 44.7996 59.355 44.9188L59.6657 45.3105ZM34.584 57.4998L34.4097 57.0312C34.2139 57.104 34.084 57.2909 34.084 57.4998H34.584ZM59.6657 45.4999H59.1657C59.1657 45.6525 59.2355 45.7968 59.355 45.8916L59.6657 45.4999ZM84.7474 57.689H85.2474C85.2474 57.4801 85.1175 57.2932 84.9216 57.2204L84.7474 57.689ZM84.7474 84.4149L84.5762 84.8847C84.7295 84.9406 84.9004 84.9182 85.0341 84.8246C85.1678 84.731 85.2474 84.5781 85.2474 84.4149H84.7474ZM59.6657 75.273L59.837 74.8032C59.7264 74.7629 59.6051 74.7629 59.4945 74.8032L59.6657 75.273ZM34.584 84.415H34.084C34.084 84.5781 34.1636 84.731 34.2973 84.8246C34.431 84.9182 34.6019 84.9406 34.7552 84.8847L34.584 84.415ZM59.6657 45.3105L59.355 44.9188C56.6878 47.0342 51.9909 49.4937 47.1618 51.7188C42.3461 53.9376 37.4471 55.9019 34.4097 57.0312L34.584 57.4998L34.7582 57.9685C37.8155 56.8318 42.7383 54.858 47.5802 52.627C52.4087 50.4022 57.2054 47.9 59.9764 45.7023L59.6657 45.3105ZM59.6657 45.4999H60.1657V45.3105H59.6657H59.1657V45.4999H59.6657ZM59.6657 45.4999L59.355 45.8916C62.1261 48.0893 66.9228 50.5915 71.7512 52.8163C76.5932 55.0472 81.5158 57.021 84.5731 58.1577L84.7474 57.689L84.9216 57.2204C81.8843 56.0911 76.9854 54.1269 72.1697 51.908C67.3406 49.683 62.6437 47.2235 59.9764 45.1081L59.6657 45.4999ZM84.7474 57.689H84.2474V84.4149H84.7474H85.2474V57.689H84.7474ZM84.7474 84.4149L84.9186 83.9452L59.837 74.8032L59.6657 75.273L59.4945 75.7428L84.5762 84.8847L84.7474 84.4149ZM34.584 84.415L34.7552 84.8847L59.837 75.7428L59.6657 75.273L59.4945 74.8032L34.4128 83.9452L34.584 84.415ZM34.584 57.4998H34.084V84.415H34.584H35.084V57.4998H34.584Z",
					fill: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M34.584 30.1893C40.6786 27.9233 54.2274 22.3131 59.6657 18V18.1893C65.1041 22.5024 78.6528 28.1126 84.7474 30.3785V57.1044L59.6657 47.9625L34.584 57.1044V30.1893Z",
					fill: "#F6DCC4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M59.6657 18H60.1657C60.1657 17.8082 60.056 17.6333 59.8833 17.5498C59.7106 17.4663 59.5053 17.4891 59.355 17.6083L59.6657 18ZM34.584 30.1893L34.4097 29.7206C34.2139 29.7934 34.084 29.9803 34.084 30.1893H34.584ZM59.6657 18.1893H59.1657C59.1657 18.3419 59.2355 18.4862 59.355 18.5811L59.6657 18.1893ZM84.7474 30.3785H85.2474C85.2474 30.1696 85.1175 29.9827 84.9216 29.9098L84.7474 30.3785ZM84.7474 57.1044L84.5762 57.5742C84.7295 57.63 84.9004 57.6076 85.0341 57.514C85.1678 57.4205 85.2474 57.2676 85.2474 57.1044H84.7474ZM59.6657 47.9625L59.837 47.4927C59.7264 47.4524 59.6051 47.4524 59.4945 47.4927L59.6657 47.9625ZM34.584 57.1044H34.084C34.084 57.2676 34.1636 57.4205 34.2973 57.5141C34.431 57.6076 34.6019 57.6301 34.7552 57.5742L34.584 57.1044ZM59.6657 18L59.355 17.6083C56.6878 19.7236 51.9909 22.1831 47.1618 24.4082C42.3461 26.6271 37.4471 28.5913 34.4097 29.7206L34.584 30.1893L34.7582 30.6579C37.8155 29.5212 42.7383 27.5474 47.5802 25.3164C52.4087 23.0917 57.2054 20.5895 59.9764 18.3917L59.6657 18ZM59.6657 18.1893H60.1657V18H59.6657H59.1657V18.1893H59.6657ZM59.6657 18.1893L59.355 18.5811C62.1261 20.7788 66.9228 23.2809 71.7512 25.5057C76.5932 27.7367 81.5158 29.7105 84.5731 30.8472L84.7474 30.3785L84.9216 29.9098C81.8843 28.7806 76.9854 26.8163 72.1697 24.5975C67.3406 22.3724 62.6437 19.9129 59.9764 17.7976L59.6657 18.1893ZM84.7474 30.3785H84.2474V57.1044H84.7474H85.2474V30.3785H84.7474ZM84.7474 57.1044L84.9186 56.6346L59.837 47.4927L59.6657 47.9625L59.4945 48.4322L84.5762 57.5742L84.7474 57.1044ZM34.584 57.1044L34.7552 57.5742L59.837 48.4322L59.6657 47.9625L59.4945 47.4927L34.4128 56.6346L34.584 57.1044ZM34.584 30.1893H34.084V57.1044H34.584H35.084V30.1893H34.584Z",
					fill: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.5834 84.6494C31.7705 71.71 33.4114 64.9679 34.5834 57.3106L59.6652 69.4998V96.6042C45.8351 92.3849 39.2716 87.4623 34.5834 84.6494Z",
					fill: "#FDF1E6",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.5834 57.3388C31.7705 44.3994 33.4114 37.6574 34.5834 30L59.6652 42.1893V69.2937C45.8351 65.0743 39.2716 60.1517 34.5834 57.3388Z",
					fill: "#F6DCC4",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M84.7467 84.6496C87.5596 71.7102 85.9187 65.1574 84.7467 57.5L59.6649 69.6893V96.6044C73.495 92.3851 80.0584 87.4625 84.7467 84.6496Z",
					fill: "#FDF1E6",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M75.288 74.4V80H74.248V75.272H73.064V74.4H75.288Z",
					fill: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M84.7467 57.339C87.5596 44.3997 85.9187 37.8468 84.7467 30.1895L59.6649 42.3787V69.2939C73.495 65.0745 80.0584 60.1519 84.7467 57.339Z",
					fill: "#F6DCC4",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M57.1534 35.9226L59.9663 41.314C60.5132 40.1419 61.7009 37.4697 62.0759 36.157C62.5447 34.5161 64.6545 31 59.4975 31C55.3719 31 56.2157 34.2817 57.1534 35.9226Z",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M82.001 24.9226L84.8139 30.314C85.3609 29.1419 86.5485 26.4697 86.9236 25.157C87.3924 23.5161 89.5021 20 84.3451 20C80.2195 20 81.0634 23.2817 82.001 24.9226Z",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.7706 23.9226L34.5835 29.314C35.1304 28.1419 36.3181 25.4697 36.6931 24.157C37.1619 22.5161 39.2717 19 34.1147 19C29.9891 19 30.8329 22.2817 31.7706 23.9226Z",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M75.408 52.12V53H71.28V52.304L73.504 50.192C73.7547 49.952 73.9227 49.744 74.008 49.568C74.0987 49.3867 74.144 49.208 74.144 49.032C74.144 48.7707 74.056 48.5707 73.88 48.432C73.704 48.2933 73.4453 48.224 73.104 48.224C72.5333 48.224 72.096 48.4187 71.792 48.808L71.064 48.248C71.2827 47.9547 71.576 47.728 71.944 47.568C72.3173 47.4027 72.7333 47.32 73.192 47.32C73.8 47.32 74.2853 47.464 74.648 47.752C75.0107 48.04 75.192 48.432 75.192 48.928C75.192 49.232 75.128 49.5173 75 49.784C74.872 50.0507 74.6267 50.3547 74.264 50.696L72.768 52.12H75.408Z",
					fill: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.8672 39.5C30.9832 39.5001 32.083 39.7675 33.0742 40.2803C34.0656 40.7933 34.9197 41.537 35.5645 42.4482C36.2092 43.3594 36.6264 44.412 36.7803 45.5176C36.918 46.5073 36.8397 47.5135 36.5557 48.4688H32.0967C32.3199 48.2191 32.5023 47.9338 32.6318 47.6211C32.8584 47.0742 32.9182 46.4722 32.8027 45.8916C32.6873 45.3111 32.4019 44.778 31.9834 44.3594C31.5648 43.9408 31.0308 43.6555 30.4502 43.54C29.8698 43.4247 29.2684 43.4836 28.7217 43.71C28.1747 43.9365 27.7068 44.3203 27.3779 44.8125C27.049 45.3048 26.873 45.8836 26.873 46.4756C26.8731 47.2138 27.149 47.9214 27.6387 48.4688H23.1777C22.8937 47.5135 22.8154 46.5073 22.9531 45.5176C23.107 44.412 23.5242 43.3594 24.1689 42.4482C24.8137 41.537 25.6678 40.7933 26.6592 40.2803C27.6505 39.7674 28.751 39.5 29.8672 39.5Z",
					fill: "#FDF1E6",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.2285 47.9912H41.6631C42.5316 47.9912 43.3368 48.6288 43.584 49.6162L49.2715 72.3779C49.8556 74.7138 48.2333 76.9111 46.1504 76.9111H13.7373C11.6544 76.911 10.0326 74.7142 10.6201 72.3789V72.3779L16.3086 49.6162C16.555 48.6298 17.3599 47.9912 18.2285 47.9912Z",
					fill: "#FDF1E6",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.7964 62.1219L25.6717 63.277V65.0906H24.3545V57.998H25.6717V61.6355L29.1774 57.998H30.6568L27.6779 61.1694L30.8391 65.0906H29.299L26.7964 62.1219Z",
					fill: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.747 59.68V64.2699C36.747 66.1748 35.7743 67.1272 33.8289 67.1272C33.3088 67.1272 32.8157 67.0597 32.3496 66.9246C31.8836 66.7962 31.4985 66.6071 31.1946 66.3572L31.762 65.4047C31.9984 65.6006 32.2956 65.756 32.6536 65.8708C33.0184 65.9924 33.3865 66.0532 33.758 66.0532C34.3524 66.0532 34.7881 65.9181 35.0651 65.6479C35.342 65.3777 35.4805 64.9657 35.4805 64.4118V64.1281C35.2644 64.3645 35.0009 64.5435 34.6902 64.6651C34.3795 64.7867 34.0383 64.8475 33.6668 64.8475C33.1535 64.8475 32.6874 64.7394 32.2686 64.5232C31.8565 64.3003 31.5289 63.9896 31.2858 63.5911C31.0493 63.1925 30.9311 62.7366 30.9311 62.2232C30.9311 61.7098 31.0493 61.2573 31.2858 60.8655C31.5289 60.4669 31.8565 60.1596 32.2686 59.9434C32.6874 59.7273 33.1535 59.6192 33.6668 59.6192C34.0586 59.6192 34.4132 59.6834 34.7307 59.8117C35.055 59.9401 35.3251 60.136 35.5413 60.3994V59.68H36.747ZM33.8593 63.7734C34.3389 63.7734 34.7307 63.6316 35.0347 63.3479C35.3454 63.0574 35.5008 62.6825 35.5008 62.2232C35.5008 61.7706 35.3454 61.4025 35.0347 61.1188C34.7307 60.8351 34.3389 60.6932 33.8593 60.6932C33.373 60.6932 32.9745 60.8351 32.6637 61.1188C32.3598 61.4025 32.2078 61.7706 32.2078 62.2232C32.2078 62.6825 32.3598 63.0574 32.6637 63.3479C32.9745 63.6316 33.373 63.7734 33.8593 63.7734Z",
					fill: "#A35705"
				})
			]
		})]
	})]
});
export default SvgMass;
